module.exports = __webpack_public_path__ + "img/daily.75e67d13.png";